var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-spinner sk-spinner-double-bounce",class:{ 'displayNone': _vm.displayNone }},[_c('div',{staticClass:"sk-double-bounce1"}),_c('div',{staticClass:"sk-double-bounce2"})])}
var staticRenderFns = []

export { render, staticRenderFns }